export default {"src":"/_next/static/media/privacy.048b4455.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};